<form class="c-contact-form"
      [formGroup]="contactForm"
      (ngSubmit)="submitContactForm()">

  <mat-form-field class="c-contact-form__control" appearance="outline">
    <mat-label>Nome</mat-label>

    <input matInput
           placeholder="Nome"
           formControlName="nome">

    <mat-error *ngIf="contactForm.get('nome').hasError('required')">
      Digite seu nome
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="hasSchool" class="c-contact-form__control" appearance="outline">
    <mat-label>Escola</mat-label>

    <input matInput
           placeholder="Nome da escola"
           formControlName="escola">

    <mat-error *ngIf="contactForm.get('escola').hasError('required')">
      Digite o nome da sua escola
    </mat-error>
  </mat-form-field>

  <mat-form-field class="c-contact-form__control" appearance="outline">
    <mat-label>Email</mat-label>

    <input matInput
           type="email"
           placeholder="Email"
           formControlName="email">

    <mat-error *ngIf="contactForm.get('email').hasError('required')">
      Digite seu email para contato
    </mat-error>

    <mat-error *ngIf="contactForm.get('email').hasError('pattern')">
      Digite um email de contato válido
    </mat-error>
  </mat-form-field>

  <mat-form-field class="c-contact-form__control" appearance="outline">
    <mat-label>Telefone</mat-label>

    <input matInput
           [redInputMask]="phoneMask"
           placeholder="(99) 99999.9999"
           formControlName="telefone">

    <mat-error *ngIf="contactForm.get('telefone').hasError('required')">
      Digite seu telefone de contato
    </mat-error>

    <mat-error *ngIf="contactForm.get('telefone').hasError('pattern')">
      Digite um telefone de contato válido
    </mat-error>
  </mat-form-field>

  <mat-form-field class="c-contact-form__control" appearance="outline">
    <mat-label>Assunto</mat-label>

    <mat-select placeholder="Assunto" formControlName="assunto">
      <mat-option *ngFor="let option of subjectOptions" [value]="option">
        {{ option }}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="contactForm.get('assunto').hasError('required')">
      Selecione o assunto do seu contato
    </mat-error>
  </mat-form-field>

  <mat-form-field class="c-contact-form__control" appearance="outline">
    <mat-label>Mensagem</mat-label>

    <textarea matInput
              placeholder="Mensagem"
              rows="5"
              formControlName="mensagem">
        </textarea>

    <mat-error *ngIf="contactForm.get('mensagem').hasError('required')">
      Digite sua mensagem
    </mat-error>
  </mat-form-field>

  <button matRipple
          [disabled]="isEmailSent"
          class="c-button c-button--large c-button--solid c-contact-form__button">
    Enviar
  </button>
</form>
